module.exports = __webpack_public_path__ + "static/finance-service-gold-f8d939246612b18180bd45b427c41712.jpg";